import { useQuery } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type OptimizationStatusResponse = {
  isInProgress: boolean;
  queueName: string | null;
  hasCompletedResults: boolean;
  completedResultsId: string | null;
};

export const checkOptimizationStatus = async (resumeId: string): Promise<OptimizationStatusResponse> => {
  const response = await axios.get<OptimizationStatusResponse>(`/resume-optimizer/status/${resumeId}`);
  return response.data;
};

export const useOptimizationStatus = (resumeId: string) => {
  return useQuery({
    queryKey: ["optimization-status", resumeId],
    queryFn: () => checkOptimizationStatus(resumeId),
    enabled: !!resumeId,
    staleTime: 5000, // Consider data stale after 5 seconds
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}; 